import { connect } from 'react-redux';
import ContainerHeader from "components/ContainerHeader/index";
import LoadingOverlay from "react-loading-overlay";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { fetchJSON } from "helpers/axios";
import { Row, Col, Card, CardBody, Button, Input } from 'reactstrap';
import Select from 'react-select';
import MaterialTable from "material-table";
import { tableIcons } from '../../../constants/Icons';
import { Cancel } from "@material-ui/icons";


import React, {
  useEffect,
  useReducer,
  Suspense,
  lazy,
  createContext,
} from "react";
import { CircularProgress } from "@material-ui/core";

class Olevel extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      hasResult: false,
      toggleAddResult: false,
      subjects: [],
      examTypes: [],
      examYears: [1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
      grades: [],
      results: [],
      examType: '',
      examYear: '',
      examNumber: '',
      subject: '',
      grade: '',
    }
  }

  async componentDidMount() {
    try {
      this.loadContent();
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  }

  loadContent = async () => {
    try {
      let applicantID = this.props.authUser.ApplicantID;
      const response = await fetchJSON(`/api/OResults/hasOlevelResult?applicantId=${applicantID}`, null, 'GET');
      const subjectResponse = await fetchJSON(`/api/Subjects/GetSubjects`, null, 'GET');
      const subjectRes = JSON.parse(subjectResponse);
      const gradeResponse = await fetchJSON(`/api/Olevel/GetGrades`, null, 'GET');
      const gradeRes = JSON.parse(gradeResponse);
      const typeResponse = await fetchJSON(`/api/OLevelType/LoadExams`, null, 'GET');
      const typeRes = JSON.parse(typeResponse);

      this.setState({
        loader: false,
        hasResult: false,
        subjects: [...subjectRes],
        grades: [...gradeRes],
        examTypes: [...typeRes],
      });
      console.log("hh", response);
      if (response.Status === "Ok") {
        this.setState({
          hasResult: true,
          results: [...response.Data]
        });
      }
    } catch (error) {
      console.log("error", error);
      this.setState({ loader: false });
      NotificationManager.error("An error occurred.");
    }
  }

  HandleChange = (name, e) => {
    let tempVal;
    if (name === "examNumber") {
      tempVal = e.target.value
      if (tempVal === null) {
        this.setState({ ...this.state, [name]: '' });
      } else {
        this.setState({ ...this.state, [name]: tempVal });
      }
    } else {
      if (e === null) {
        this.setState({ ...this.state, [name]: '' });
      } else {
        tempVal = e.value;
        this.setState({ ...this.state, [name]: tempVal });
      }
    }
  }

  AddResult = () => {
    const { examType, subject, examNumber, results, grade, examYear } = this.state;
    let applicantID = this.props.authUser.ApplicantID;
    if (examType == '') {
      NotificationManager.error("Examination Type is required.");
      return false;
    }
    if (examYear == '') {
      NotificationManager.error("Examination Year is required.");
      return false;
    }
    if (examNumber == '') {
      NotificationManager.error("Examination Number is required.");
      return false;
    }
    if (subject == '') {
      NotificationManager.error("Subject is required.");
      return false;
    }
    if (grade == '') {
      NotificationManager.error("Grade is required.");
      return false;
    }

    var r = {
      OLevelSubjectID: subject,
      OLevelTypeID: examType,
      OLevelGradeID: grade,
      ApplicantId: applicantID,
      ExamYear: examYear,
      ExamNumber: examNumber
    }

    let tempresults = this.state.results.filter((r) => r.OLevelSubjectID === subject);
    if (tempresults.length > 0) {
      NotificationManager.error("Subject added already.");
      return false;
    }
    results.push(r);
    this.setState({ results: results })
    NotificationManager.success("Result Added.");
  }

  AddIndividualResult = async () => {
    try {
      const { examType, subject, examNumber, results, grade, examYear } = this.state;
      let applicantID = this.props.authUser.ApplicantID;
      if (examType == '') {
        NotificationManager.error("Examination Type is required.");
        return false;
      }
      if (examYear == '') {
        NotificationManager.error("Examination Year is required.");
        return false;
      }
      if (examNumber == '') {
        NotificationManager.error("Examination Number is required.");
        return false;
      }
      if (subject == '') {
        NotificationManager.error("Subject is required.");
        return false;
      }
      if (grade == '') {
        NotificationManager.error("Grade is required.");
        return false;
      }

      var r = {
        OLevelSubjectID: subject,
        OLevelTypeID: examType,
        OLevelGradeID: grade,
        ApplicantId: applicantID,
        ExamYear: examYear,
        ExamNumber: examNumber
      }

      this.setState({ loader: true });
      const Response = await fetchJSON(`api/OResults/PostEachOResult`, r, 'POST');
      console.log(Response);
      if (Response.Status === 'Ok') {
        this.loadContent();
        NotificationManager.success("Subject added successfully.");
      } else {
        NotificationManager.error(Response.Message);
      }
      this.setState({ loader: false });
    } catch (e) {

    }
  }

  showGrade = (gradeID) => {
    let grades = this.state.grades.filter((grade) => grade.OLevelGradeID === gradeID);
    return grades[0].GradeName;
  }

  showSubject = (subjectID) => {
    let subject = this.state.subjects.filter((subject) => subject.OLevelSubjectID === subjectID);
    return subject[0].OLevelSubjectName;
  }

  showExamType = (examTypeID) => {
    let examType = this.state.examTypes.filter((examType) => examType.OLevelTypeID === examTypeID);
    return examType[0].OLevelTypeName;
  }

  removeResult = (result) => {
    let results = this.state.results.filter((r) => r.OLevelSubjectID !== result.OLevelSubjectID);
    this.setState({ ...this.state, results: results });
  }

  deleteResult = async (result) => {
    try {
      const resultId = result.OLevelResultID;

      let r = confirm("Are you sure");
      if (r === true) {
        this.setState({ loader: true });
        const Response = await fetchJSON(`api/OResults/DeleteOResult/?olevelresultId=${resultId}`, null, 'DELETE');
        if (Response === 'Deleted') {
          this.loadContent();
          NotificationManager.success("Subject deleted successfully.");
        } else {
          NotificationManager.error("Unable to complete operation.");
        }
        this.setState({ loader: false });
      }
    } catch (ex) {

    }
  }

  SendResult = async () => {
    const { results } = this.state;
    if (results.length < 8) {
      NotificationManager.error("Subject can not be less than 8.");
      return false;
    }
    this.setState({ ...this.state, loader: false })
    const response = await fetchJSON(`api/OResults/PostOResult`, results, 'POST');
    this.setState({ ...this.state, loader: false })
    console.log(results);
    if (response === "Success") {
      NotificationManager.success("Congratulations, Olevel added successfully.");
      this.loadContent();
    } else {
      NotificationManager.error("Unable to complete operation.");
    }

  }

  render() {
    const { match, width } = this.props;
    const { examTypes, subjects, hasResult, results, grades, examYears, loader, toggleAddResult } = this.state;


    return (
      <>
        <div className="app-wrapper">
          <div className="dashboard animated slideInUpTiny animation-duration-3">
            <ContainerHeader match={match} title="Olevel" />

            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200 ? "calc(100vh - 265px)" : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
              <LoadingOverlay
                active={loader}
                spinner
                text="Fetching Data"
              >

                {
                  hasResult ?
                    <>
                      <Card>
                        <Col xl={12}>
                          <Button onClick={(e) => this.setState({ ...this.state, toggleAddResult: !toggleAddResult })} color="success" className="mt-3 mb-4 float-right">
                            Add Result
                              </Button>
                        </Col>
                        {
                          (toggleAddResult === true && hasResult === true) &&
                          <CardBody>
                            <h4 className="header-title mt-0 mb-1">Add O'level Result</h4>
                            <Row>
                              <Col lg={4} sm={12}>
                                <p className="mb-1 mt-3 font-weight-bold">Examination Type</p>
                                <Select
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  options={
                                    examTypes.map((examType) => ({ value: examType.OLevelTypeID, label: examType.OLevelTypeName }))
                                  }
                                  name="examTypeId"
                                  onChange={(e) => this.HandleChange('examType', e)}
                                >
                                </Select>
                              </Col>
                              <Col lg={4} sm={12}>
                                <p className="mb-1 mt-3 font-weight-bold">Examination Year</p>
                                <Select
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  options={
                                    examYears.map((examYear) => ({ value: examYear, label: examYear }))
                                  }
                                  name="examTypeId"
                                  onChange={(e) => this.HandleChange('examYear', e)}
                                >
                                </Select>
                              </Col>
                              <Col lg={4} sm={12}>
                                <p className="mb-1 mt-3 font-weight-bold">Examination Number</p>
                                <Input
                                  type="text"
                                  name="examNumber"
                                  id="examNumber"
                                  placeholder="Examination Number"
                                  onChange={(e) => this.HandleChange('examNumber', e)}
                                />
                              </Col>
                              <Col lg={6} sm={12}>
                                <p className="mb-1 mt-3 font-weight-bold">Subject</p>
                                <Select
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  options={
                                    subjects.map((subject) => ({ value: subject.OLevelSubjectID, label: subject.OLevelSubjectName }))
                                  }
                                  name="examTypeId"
                                  onChange={(e) => this.HandleChange('subject', e)}
                                >
                                </Select>
                              </Col>
                              <Col lg={6} sm={12}>
                                <p className="mb-1 mt-3 font-weight-bold">Grade</p>
                                <Select
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  options={
                                    grades.map((grade) => ({ value: grade.OLevelGradeID, label: grade.GradeName }))
                                  }
                                  name="examTypeId"
                                  onChange={(e) => this.HandleChange('grade', e)}
                                >
                                </Select>
                              </Col>

                            </Row>
                            <Row>
                              <Col xl={12}>
                                <Button onClick={this.AddIndividualResult} color="success" className="mt-3 float-right">
                                  Add
                                        </Button>
                              </Col>
                            </Row>

                          </CardBody>
                        }
                      </Card>
                      <MaterialTable
                        icons={tableIcons}
                        title="My Results"
                        columns={[
                          {
                            title: 'S/N',
                            render: rowData => rowData.tableData.id + 1
                          },
                          {
                            title: 'Exam Type',
                            render: rowData => this.showExamType(rowData.OLevelTypeID)
                          },
                          { title: 'Exam Year', field: 'ExamYear' },
                          { title: 'Exam Number', field: 'ExamNumber' },
                          {
                            title: 'Subject',
                            render: rowData => this.showSubject(rowData.OLevelSubjectID)
                          },
                          {
                            title: 'Exam Grade',
                            render: rowData => this.showGrade(rowData.OLevelGradeID)
                          },
                        ]}
                        data={results}
                        actions={[
                          {
                            icon: () => <Cancel color="error" />,
                            tooltip: 'Remove',
                            onClick: (event, rowData) => { this.deleteResult(rowData) }
                          },
                        ]}
                        options={{
                          actionsColumnIndex: -1,
                          exportButton: true,
                          pageSize: 15,
                        }}
                      />
                    </>
                    :
                    <Card>
                      <CardBody>
                        <h4 className="header-title mt-0 mb-1">Add O'level Result</h4>
                        <Row>
                          <Col lg={4} sm={12}>
                            <p className="mb-1 mt-3 font-weight-bold">Examination Type</p>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              options={
                                examTypes.map((examType) => ({ value: examType.OLevelTypeID, label: examType.OLevelTypeName }))
                              }
                              name="examTypeId"
                              onChange={(e) => this.HandleChange('examType', e)}
                            >
                            </Select>
                          </Col>
                          <Col lg={4} sm={12}>
                            <p className="mb-1 mt-3 font-weight-bold">Examination Year</p>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              options={
                                examYears.map((examYear) => ({ value: examYear, label: examYear }))
                              }
                              name="examTypeId"
                              onChange={(e) => this.HandleChange('examYear', e)}
                            >
                            </Select>
                          </Col>
                          <Col lg={4} sm={12}>
                            <p className="mb-1 mt-3 font-weight-bold">Examination Number</p>
                            <Input
                              type="text"
                              name="examNumber"
                              id="examNumber"
                              placeholder="Examination Number"
                              onChange={(e) => this.HandleChange('examNumber', e)}
                            />
                          </Col>
                          <Col lg={6} sm={12}>
                            <p className="mb-1 mt-3 font-weight-bold">Subject</p>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              options={
                                subjects.map((subject) => ({ value: subject.OLevelSubjectID, label: subject.OLevelSubjectName }))
                              }
                              name="examTypeId"
                              onChange={(e) => this.HandleChange('subject', e)}
                            >
                            </Select>
                          </Col>
                          <Col lg={6} sm={12}>
                            <p className="mb-1 mt-3 font-weight-bold">Grade</p>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              options={
                                grades.map((grade) => ({ value: grade.OLevelGradeID, label: grade.GradeName }))
                              }
                              name="examTypeId"
                              onChange={(e) => this.HandleChange('grade', e)}
                            >
                            </Select>
                          </Col>

                        </Row>
                        <Row>
                          <Col xl={12}>
                            <Button onClick={this.AddResult} color="success" className="mt-3 float-right">
                              Add Result
                            </Button>
                          </Col>
                        </Row>

                      </CardBody>

                      {
                        results.length > 0 &&
                        <Row>
                          <Col md={12} className="mt-3">
                            <Button onClick={this.SendResult} color="success" className="mt-3 mr-4 float-right">
                              Send Result
                          </Button>
                          </Col>
                          <Col md={12} className="mt-3">
                            <MaterialTable
                              icons={tableIcons}
                              title="Results"
                              columns={[
                                {
                                  title: 'S/N',
                                  render: rowData => rowData.tableData.id + 1
                                },
                                {
                                  title: 'Exam Type',
                                  render: rowData => this.showExamType(rowData.OLevelTypeID)
                                },
                                { title: 'Exam Year', field: 'ExamYear' },
                                { title: 'Exam Number', field: 'ExamNumber' },
                                {
                                  title: 'Subject',
                                  render: rowData => this.showSubject(rowData.OLevelSubjectID)
                                },
                                {
                                  title: 'Exam Grade',
                                  render: rowData => this.showGrade(rowData.OLevelGradeID)
                                },
                              ]}
                              data={results}
                              actions={[
                                {
                                  icon: () => <Cancel color="error" />,
                                  tooltip: 'Remove',
                                  onClick: (event, rowData) => { this.removeResult(rowData) }
                                },
                              ]}
                              options={{
                                actionsColumnIndex: -1,
                                exportButton: true,
                                pageSize: 15,
                              }}
                            />
                          </Col>
                        </Row>
                      }

                    </Card>
                }
              </LoadingOverlay>
            </Suspense>

          </div>
          <NotificationContainer />
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth;
  return { authUser };
};

export default connect(mapStateToProps, {})(Olevel);
